"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_LABELS_FRAGMENT = void 0;
var _fetching = require("@ori/fetching");
const PRODUCT_LABELS_FRAGMENT = exports.PRODUCT_LABELS_FRAGMENT = (0, _fetching.gql)`
  fragment ProductLabels on ProductLabel {
    labelKey
    productLabelDomain
    title
  }
`;
